export type FormHeading = {
  text: string;
  type: 'error' | 'message';
};

const headingMap = new Map<string, FormHeading>([
  [
    'hasErrored',
    {
      text: 'Unable to set your location, please try again.',
      type: 'error'
    }
  ],
  [
    'isExcludedLocation',
    {
      text: 'Please update your ZIP code to purchase from a different location',
      type: 'error'
    }
  ],
  [
    'isDeliveryAllowed',
    {
      text: "We'll show you the most accurate shipping cost and delivery estimates based on your location.",
      type: 'message'
    }
  ]
]);

type Options = {
  hasErrored: boolean;
  isExcludedLocation: boolean;
  isDeliveryAllowed: boolean;
};

const getFirstTruthyOption = (options: Options): string => {
  const [firstTruthyOption = ''] =
    Object.entries(options).find(([, val]) => val) ?? [];

  return firstTruthyOption;
};

export default function getFormHeading({
  hasErrored,
  isExcludedLocation,
  isDeliveryAllowed
}: Options) {
  const headingOption = getFirstTruthyOption({
    hasErrored,
    isExcludedLocation,
    isDeliveryAllowed
  });

  const formHeading = headingMap.get(headingOption);

  return (
    formHeading ?? {
      text: 'Or you can update your ZIP code to purchase from a different location.',
      type: 'message'
    }
  );
}
